import conf from "@/configuration/env-config.js"

export default (key) => {
    return (window._env_ && window._env_[key]) || conf[key];
};